export default function ConfigDataRangeMock() {
  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" /> Data Range</div>
      <div className="platform-mock-body">
        <div className="mock-sidebar-section">
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Mode</span>
            <span className="mock-toggle">
              <span className="mock-toggle-opt">Date</span>
              <span className="mock-toggle-opt active">Candle</span>
            </span>
          </div>
          <div className="mock-subtitle-hint">Evaluate a fixed sample size</div>
          <div className="mock-range-track">
            <div className="mock-range-fill" style={{ width: '63%' }} />
            <div className="mock-range-thumb" style={{ left: '63%' }} />
          </div>
          <div className="mock-range-labels"><span>Candle 1</span><span>Candle 2,000</span></div>
          <div className="mock-range-dates"><span>Aug 17, 17</span><span>Feb 6, 23</span></div>
          <div className="mock-range-summary">
            <span style={{ color: '#6b7280' }}>3,140 total</span>
            <span style={{ color: '#9d4edd', fontWeight: 700 }}>2,000 selected</span>
          </div>
          <div className="mock-presets">
            <span className="mock-preset-chip">500</span>
            <span className="mock-preset-chip">1k</span>
            <span className="mock-preset-chip" style={{ borderColor: 'rgba(157,78,221,0.4)', color: '#9d4edd' }}>2k</span>
            <span className="mock-preset-chip">5k</span>
            <span className="mock-preset-chip">All</span>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">Choose a date range or a fixed candle count. More data means more trades and more statistical confidence.</div>
    </div>
  );
}
